'use client';

import style from './loading.module.scss';
import React, { FC } from 'react';
import { GridLoader } from 'react-spinners';
import classNames from 'classnames';
import { useAppSelector } from '../v2/hooks/useAppSelector/UseAppSelector';
import { useIsSidebarOpenSelector } from '../v2/store/selectors';
import { useCheckIsMobileView } from '../v2/hooks/useCheckIsMobileView/useCheckIsMobileView';

type Props = {
  className?: string;
};

const Loading: FC<Props> = ({ className = '' }) => {
  const isMenuOpen = useAppSelector(useIsSidebarOpenSelector);
  const { isTabletView, isMobileView } = useCheckIsMobileView();
  return (
    <></>
    // <div
    //   className={classNames(
    //     style['container'],
    //     {
    //       [style['container--open']]:
    //         isMenuOpen && !isTabletView && !isMobileView,
    //       [style['container--closed']]:
    //         !isMenuOpen || isTabletView || isMobileView,
    //     },
    //     { [className]: !!className }
    //   )}
    // >
    //   <div className={style['logo-container']}>
    //     <GridLoader
    //       color="#FF53FF"
    //       className={style['loading-spinner']}
    //       size={24}
    //     />
    //   </div>
    // </div>
  );
};

export default Loading;
